import './Block.sass';

import React, { FC } from 'react';

import { classNames } from '$utils';
import { BlockProps } from '$uikit/Block/Block.interface';

export const Block: FC<BlockProps> = (props) => {
  const { children, className = '', onClick, style = {} } = props;

  return (
    <div
      className={classNames({
        Block: true,
        [className]: !!className,
      })}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
};
